export const COLLECTION_SLUG = 'do-thu-dong'

export type TGender = 'MALE' | 'FEMALE'

export const GENDERS: TGender[] = ['MALE', 'FEMALE']
export const DEFAULT_GENDER: TGender = 'MALE'

/** Số sản phẩm hiển thị trên rail "Lựa chọn cho mùa mới" */
export const RAIL_LIMIT = 12

export const TRACKING_PREFIX = 'ldp-thu-dong'

// TODO: chốt link với PO, hiện đang trỏ về trang tổng Nam/Nữ
export const GENDER_LINKS: Record<TGender, string> = {
  MALE: '/collection/thu-dong-2026?danh-muc=do-nam',
  FEMALE: '/collection/thu-dong-2026?danh-muc=do-nu',
}

/* ------------------------------ Stories ------------------------------ */

export type TStory = {
  key: string
  image: string
  links: { key: string; href: string }[]
}

// TODO: link Recover chưa có collection riêng
export const STORIES: TStory[] = [
  {
    key: 'recover',
    image: '/image/2026/11/03/dtd26v2-story-1.jpg',
    links: [
      { key: 'recover', href: '/collection/thu-dong-2026-vai-modal-go-soi' },
    ],
  },
  {
    key: 'move',
    image: '/image/2026/11/03/dtd26v2-story-2.jpg',
    links: [
      { key: 'male', href: GENDER_LINKS.MALE },
      { key: 'female', href: GENDER_LINKS.FEMALE },
    ],
  },
  {
    key: 'transition',
    image: '/image/2026/11/03/dtd26v2-story-3.jpg',
    links: [
      {
        key: 'male',
        href: '/collection/ao-khoac-nam?danh-muc=ao-khoac-phao',
      },
      { key: 'female', href: '/collection/ao-khoac-nu' },
    ],
  },
]

/* ------------------------------- Banner ------------------------------ */

export const SMART_BANNER_IMAGE = '/image/2026/11/03/dtd26v2-banner.jpg'
export const SMART_BANNER_IMAGE_MOBILE = '/image/2026/11/05/Image12222.jpg'
/** id section "Chi tiết thiết kế & công nghệ vải" — đích của CTA banner */
export const DETAILS_SECTION_ID = 'cong-nghe-vai'

/* ------------------------------ Chi tiết ----------------------------- */

export type TDetailItem = {
  image: string
  productIds: string[]
}

export const DETAIL_ITEMS: TDetailItem[] = [
  {
    image: '/image/2026/10/27/dtd26-detail-1_98.jpg',
    productIds: [
      '6acf1ee39bc1d127263f98f8',
      '6acf04c5ebb6da2dd55f763a',
      '6ac47af7a5068e70593d0fce',
      '6908541548c6bd705e63cc89',
    ],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-2_46.jpg',
    productIds: ['6ac47af7a5068e70593d0fce', '6aa770037cc7b73970562f0c'],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-3_4.jpg',
    productIds: ['68b7b5711f6a2013dd4e85c5', '6943bdf29dedff448224ff49'],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-4.jpg',
    productIds: [
      '6ac7acaf7eb1da0f3368d853',
      '68fa252da1028448e950ba96',
      '6acc84b00ec068736740a08b',
    ],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-5.jpg',
    productIds: ['6ad8661bd6da47754d5457c2', '6ad716e1d1dd5e03c61fa835'],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-6_84.jpg',
    productIds: ['633127cf95e4c74c770b51c9'],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-7.jpg',
    productIds: ['6732b77099064b41ec09a84d'],
  },
  {
    image: '/image/2026/10/27/dtd26-detail-8.jpg',
    productIds: [
      '68fcfea19ef24235c03e29e3',
      '6a9fcdd400d8023ef376931f',
      '6a9948e22b8a48197d1e0c83',
    ],
  },
]

/* ---------------------------- Ba lớp chất liệu ---------------------------- */

export const LAYER_ITEMS: { image: string; icons: [string, string] }[] = [
  {
    image: '/image/2026/11/03/dtd26v2-layer-1.jpg',
    icons: [
      '/image/2026/11/03/dtd26v2-icon-thoai-mai.png',
      '/image/2026/11/03/dtd26v2-icon-khang-khuan.png',
    ],
  },
  {
    image: '/image/2026/11/03/dtd26v2-layer-2.jpg',
    icons: [
      '/image/2026/11/03/dtd26v2-icon-tham-hut.png',
      '/image/2026/11/03/dtd26v2-icon-nhanh-kho.png',
    ],
  },
  {
    image: '/image/2026/11/03/dtd26v2-layer-3.jpg',
    icons: [
      '/image/2026/11/03/dtd26v2-icon-truot-nuoc.png',
      '/image/2026/11/03/dtd26v2-icon-do-ben-cao.png',
    ],
  },
]

/* ------------------------------ Mix & match ----------------------------- */

export const MIX_MATCH_ITEMS: { thumbnail: string; productIds: string[] }[] = [
  {
    thumbnail: '/image/2026/10/27/Artboard_1532.jpg',
    productIds: [
      '6aa770037cc7b73970562f0c',
      '6ad58028b55fda3ab742a0d2',
      '6ac47af7a5068e70593d0fce',
      '6adeb9e9674e4d3ac55b5111',
    ],
  },
  {
    thumbnail: '/image/2026/10/27/image211.jpg',
    productIds: [
      '6ad96e4a18403623212a1166',
      '6ab617af2f3dc657c870f6f0',
      '65eea30410ca23562b38b0ea',
    ],
  },
  {
    thumbnail: '/image/2026/10/27/image-12.jpg',
    productIds: [
      '6aadf7cbfa1be13e16695df0',
      '693b8a33e5995f70c0570edc',
      '6ad19a1642ed467a26646994',
    ],
  },
  {
    thumbnail: '/image/2026/10/27/image-21.jpg',
    productIds: ['6acf04c5ebb6da2dd55f763a', '6a9e807e41632c72b33e5b65'],
  },
  {
    thumbnail: '/image/2026/11/03/dtd26v2-look-5.jpg',
    productIds: [
      '68fcfea19ef24235c03e29e3',
      '67c6d8942e051c1c9d68405d',
      '67c6fc4c35c9835e9967696c',
    ],
  },
  {
    thumbnail: '/image/2026/11/03/dtd26v2-look-6.jpg',
    productIds: [
      '6709d6b149cc3526d669a161',
      '6ad8661bd6da47754d5457c2',
      '65792be0fbe98b5c146c6393',
    ],
  },
  {
    thumbnail: '/image/2026/11/03/dtd26v2-look-7.jpg',
    productIds: ['6ad58028b55fda3ab742a0d2', '6ac34747d99397075d18b2da'],
  },
  {
    thumbnail: '/image/2026/11/03/dtd26v2-look-8.jpg',
    productIds: ['6ae04a59b8d7bb24a8064e7e'],
  },
]
